<script>
import CampaignContent from "@/components/campaignContent";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  components: {
    CampaignContent,
    Layout,
  },
  async created() {
    this.$store.commit('loader/START_LOADING');
    try {
      const {data} = await axios.get(`/admin/campaign/${this.campaignId}/overview`);
      this.campaign = data;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  computed: {
    clientId() {
      return this.$route.params.clientId
    },
    campaignId() {
      return this.$route.params.campaignId
    },
  },
  data() {
    return {
      campaign: null,
    }
  },
}
</script>

<template>
  <Layout>
    <div class="mb-3">
      <router-link tag="a" class="btn btn-primary" :to="`/admin/clients/${clientId}/campaigns`">
        <i class="mdi mdi-arrow-left mr-1"></i>Back
      </router-link>
    </div>
    <campaign-content v-if="campaign" :campaign="campaign"></campaign-content>
  </Layout>
</template>

<style scoped>

</style>
